import type { Brand } from "@borealis/layout-express";

export const validateSSN = (ssn: string, brand: Brand): boolean => {
  const formattedBrand = brand.toLowerCase();
  const ssnPatterns: Record<"dba" | "finn" | "blocket", RegExp> = {
    finn: /^(0[1-9]|[12][0-9]|3[01])(0[1-9]|1[0-2])\d{5}$/,
    blocket: /^(19|20)?\d{6}[- ]?\d{4}$/,
    dba: /^\d{6}-?\d{4}$/,
  };

  const pattern = ssnPatterns[formattedBrand as keyof typeof ssnPatterns];
  if (!pattern) return false;

  return pattern.test(ssn);
};
